var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFillRing = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13 14c-.901102 2.466663-2.689588 4.130041-5.5265221 3.782055-2.3514856-.288439-5.4656693-2.167916-3.4540767-5.673083 1.7934064-3.12498 10.3622298-1.891027 8.9805988 1.891028z",
    style: {
      fill: "#8cbe8c",
      fillRule: "evenodd",
      stroke: "#555753",
      strokeWidth: 0.808193,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(33 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c4a000",
    height: 11,
    rx: 2.01149,
    width: 11,
    x: -20,
    y: 13
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fcffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-15 14v2.0625c-.537663.111041-1.024662.383291-1.375.78125l-1.78125-1.03125-.5.875 1.78125 1.03125c-.082063.247432-.125.506395-.125.78125s.04294.533818.125.78125l-1.78125 1.03125.5.875 1.78125-1.03125c.352503.40042.832682.670182 1.375.78125v2.0625h1v-2.0625c.537663-.111041 1.024662-.383291 1.375-.78125l1.78125 1.03125.5-.875-1.78125-1.03125c.082063-.247432.125-.506395.125-.78125s-.04294-.533818-.125-.78125l1.78125-1.03125-.5-.875-1.78125 1.03125c-.352503-.40042-.832682-.670182-1.375-.78125v-2.0625zm.5 3.5c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-19 19 9-.0096s0 0 0-2c0-2.9904-1-2.9904-4.5-2.9904s-4.5 0-4.5 3z",
    fillRule: "evenodd",
    opacity: 0.3
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.0273438 9.5019527c-2.8183472.046637-5.2870436 1.2538893-6.2832032 4.1933593-.98846778 2.916771 1.1705509 8.183302 5.9316406 5.841797 7.9077408-3.889027 7.9039248.962891 9.8808598.962891 2.438571 0 4.941406-1.699014 4.941406-3.873047 0-1.944514.0964-3.806221-.992188-4.876953-1.976935-1.9445144-2.973668.986007-8.289062-1.185547-1.694017-.6920749-3.4984442-1.0904833-5.1894532-1.0625003zm1.34375 1.9042973c2.6717632.209714 3.4212382 1.491217 3.2539062 2.84375-.152982.801242-.112181 1.757194-2.3125 2.125-2.2667232.311628-2.8421214 1.897626-5.375.4375-1.2343757-.806891-1.2032043-1.958912-.75-2.875 1.002077-1.698078 2.6725424-2.608437 5.1835938-2.53125z",
    fill: "#bebebe",
    fillRule: "evenodd",
    stroke: "#555753",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFillRing, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fill_ring.682037ca.svg";
export { ForwardRef as ReactComponent };